import { Injectable } from '@angular/core';
import { IFilters } from 'app/models/filter.models';
import { ICitationForExport } from 'app/models/geo-spacial.models';
import { PageType } from 'app/models/pdf.models';
import { Base64Image, IExportableChart, PdfBuilder, preparePrintableFilters } from 'app/utils/pdf.utils';
import { AuthService } from './auth.service';
import { DepartmentService } from './department.service';
import { Observable, firstValueFrom, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(
    private authService: AuthService,
    private departmentService: DepartmentService,
  ) {}

  async generateChartReportFile(
    pageType: PageType,
    charts: IExportableChart[],
    filters: IFilters | null,
    fileName: string,
    title?: string,
  ) {
    const pdf = new PdfBuilder();
    if (title) {
      pdf.addDocumentTitle(title);
    }
    const departmentName = await firstValueFrom(this.getDepartmentName(filters));
    if (filters) {
      const printableFilters = preparePrintableFilters(filters, pageType);
      pdf.addFiltersInfo(printableFilters, departmentName);
    }
    pdf.addCharts(charts).saveToFile(fileName);
  }

  async generateMapReportFile(
    mapImage: Base64Image,
    citations: ICitationForExport[],
    filters: IFilters | null,
    fileName: string,
  ) {
    const pdf = new PdfBuilder();
    pdf.addDocumentTitle('Report - Map');
    const departmentName = await firstValueFrom(this.getDepartmentName(filters));

    if (filters) {
      const printableFilters = preparePrintableFilters(filters, PageType.MAP);
      pdf.addFiltersInfo(printableFilters, departmentName);
    }
    pdf.addMapImage(mapImage);
    if (citations) {
      pdf.addCitationsTable(citations);
    }
    pdf.saveToFile(fileName);
  }

  private getDepartmentName(filters: IFilters | null): Observable<string | null> {
    let departmentId: string | undefined;
    if (filters?.departmentId) {
      departmentId = filters.departmentId;
    } else {
      if (!this.authService.isAdmin) {
        departmentId = this.authService.getDepartmentId();
      } else {
        return of('All Agencies');
      }
    }
    if (!departmentId) {
      return of(null);
    } else {
      return this.departmentService.getDepartment(departmentId).pipe(map((value) => value.name));
    }
  }
}
